/**
 * @module Section-Home2-Enhanced-Services
 */

import { NavLink } from "react-router-dom";
import { navUrl } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionServices, TypeSectionTechnologies } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";

/**
 * Enhanced Services Section with modern card design
 * @param props : Data supplied to display services
 * @returns Enhanced services markup template
 */
const SectionHome2EnhancedServices = (
    props: {
        _services: TypeSectionServices,
        _technologies: TypeSectionTechnologies
    }
) => {
    const { _services, _technologies } = props;
    
    // Map services to our updated routes (Systems Integration removed)
    const getServiceRoute = (index: number) => {
        const routes = [
            route.services.IT_CONSULTANCY,
            route.services.CUSTOM_SOFTWARE,
            route.services.MOBILE_DEVELOPMENT,
            route.services.PAYMENT_GATEWAY,
            route.services.IT_SECURITY
        ];
        return routes[index] || route.services.IT_CONSULTANCY;
    };


    return (
        <div id="services" className="section-full p-t120 wow fadeInDown p-b90 site-bg-gray" data-wow-offset={100} data-wow-delay="0.2">
            <div className="container">
                <div className="section-content">
                    <div className="av-content-title text-center m-b60">
                        <h2 className="av-large-title">Our Core Services</h2>
                        <p className="p-text" style={{ maxWidth: '600px', margin: '0 auto', fontSize: '18px', color: '#64748b' }}>
                            We provide comprehensive technology solutions that help businesses transform their operations and achieve sustainable growth.
                        </p>
                    </div>
                    
                    {/* Desktop Services - Original Layout */}
                    <div className="av-icon-style-1 row g-0">
                        {
                            _services.services.map((_item, _index) => {
                                return (
                                    <div key={_index} className="col">
                                        <div className="av-icon-style-1-blocks">
                                            <div className="av-media">
                                                <span>
                                                    <AvertImage src={_item.icon} alt="icon" />
                                                </span>
                                            </div>
                                            <div className="av-content">
                                                <h3 className="av-title">
                                                    <NavLink to={navUrl.services(getServiceRoute(_index))}>
                                                        {_item.title}
                                                    </NavLink>
                                                </h3>
                                                <p>{_item.description || 'Professional technology service tailored to your business needs.'}</p>
                                                <div className="av-readmore-btn">
                                                    <NavLink 
                                                        className="site-button button-sm gray" 
                                                        to={navUrl.services(getServiceRoute(_index))}
                                                    >
                                                        Read More <i className="feather feather-plus"></i>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    
                    {/* Mobile Services - Hidden on Desktop */}
                    <div className="mobile-only">
                        <div className="mobile-services-grid">
                            {
                                _services.services.map((_item, _index) => {
                                    return (
                                        <div key={_index} className="service-item">
                                            <div className="mobile-service-card">
                                                <div className="av-media">
                                                    <span>
                                                        <AvertImage src={_item.icon} alt="icon" />
                                                    </span>
                                                </div>
                                                <div className="av-content">
                                                    <h3 className="av-title">
                                                        <NavLink to={navUrl.services(getServiceRoute(_index))}>
                                                            {_item.title}
                                                        </NavLink>
                                                    </h3>
                                                    <p>{_item.description || 'Professional technology service tailored to your business needs.'}</p>
                                                    <div className="av-readmore-btn">
                                                        <NavLink 
                                                            className="site-button button-sm gray" 
                                                            to={navUrl.services(getServiceRoute(_index))}
                                                        >
                                                            Read More <i className="feather feather-plus"></i>
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    
                    <div className="av-client-slider1 p-t50 p-b20 site-bg-white">
                        <div className="owl-carousel home-client-carousel3 owl-btn-vertical-center">
                            {
                                _technologies.technologies.map((_tech, _index) => {
                                    return (
                                        <div key={_index} className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <AvertImage src={_tech} alt="technology" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionHome2EnhancedServices; 